// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import estimateTemplateApi from '~/apis/estimateTemplate';
import {
  CREATE_NEW_ESTIMATE_TEMPLATE,
  DELETE_ESTIMATE_TEMPLATE,
  GET_ESTIMATE_TEMPLATE_DETAILS,
  GET_LIST_ESTIMATE_TEMPLATE,
  UPDATE_ESTIMATE_TEMPLATE,
} from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';
import { IUpdateTemplateBody } from '~/utils/interface/estimateTemplate';

export const createEstimateTemplate = createAsyncThunk(
  CREATE_NEW_ESTIMATE_TEMPLATE,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const resp = await estimateTemplateApi.createEstimateTemplate(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEstimateTemplateList = createAsyncThunk(
  GET_LIST_ESTIMATE_TEMPLATE,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await estimateTemplateApi.getEstimateTemplateList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEstimateTemplate = createAsyncThunk(
  DELETE_ESTIMATE_TEMPLATE,
  async (estimateTemplateId: string, { rejectWithValue }) => {
    try {
      const resp = await estimateTemplateApi.deleteEstimateTemplate(estimateTemplateId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateEstimateTemplate = createAsyncThunk(
  UPDATE_ESTIMATE_TEMPLATE,
  async (payload: IUpdateTemplateBody, { rejectWithValue }) => {
    try {
      const resp = await estimateTemplateApi.updateEstimateTemplate(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEstimateTemplateDetails = createAsyncThunk(
  GET_ESTIMATE_TEMPLATE_DETAILS,
  async (templateId: string, { rejectWithValue }) => {
    try {
      const resp = await estimateTemplateApi.getEstimateTemplateDetails(templateId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
